import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../index";
import { InvitationsAPI } from "../../services/invitations/invitations.service";
import { InvitationCoordinates, Invitations } from "../../services/invitations/dto/invitations.dto";
import { DEFAULT_COORDINATES } from "../../../constants";

interface mapsState {
	coordinates: InvitationCoordinates;
}

const initialState: mapsState = {
	coordinates: DEFAULT_COORDINATES
};

const mapsSlice = createSlice({
	name: "maps",
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addMatcher(InvitationsAPI.endpoints.getWeddingInvitation.matchFulfilled, (state, action) => {
				const { invitation } = action.payload as { invitation: Invitations };
				state.coordinates = invitation.wedding_coordinates;
			})
			.addMatcher(InvitationsAPI.endpoints.getManageWeddingInvitation.matchFulfilled, (state, action) => {
				const { invitation } = action.payload as { invitation: Invitations };
				state.coordinates = invitation.wedding_coordinates;
			});
	}
});

export const {} = mapsSlice.actions;
export const getFullMapsState = (state: RootState): mapsState => state.maps;
export default mapsSlice.reducer;
